
import { Component, Vue, Prop } from "vue-property-decorator";
import { LoginTwoFactorCommand } from "../services/api/models/LoginTwoFactorCommand.model";
import { accountApi } from "../services/api/account/account";

@Component({})
export default class TwoFactorCode extends Vue {
  @Prop() readonly modalTwoFactor: boolean = false;
  @Prop() readonly returnUrl: any;
  @Prop() readonly user: any;
  @Prop() readonly remember: any;

  private code = "";
  private isSendProfile = false;
  private errorMessageShow = false;
  private errorMessage = "";
  private errors: string[] = [];
  $t: any;

  async send() {
    this.isSendProfile = true;
    this.errors = [];

    try {
      const request = new LoginTwoFactorCommand(
        this.returnUrl,
        this.user,
        this.code,
        this.remember
      );
      const response = await accountApi.loginTwoFactor(request);
      this.$emit("twofactor", response);
    } catch (err) {
      console.log(err.response);
      if (err?.response?.status === 400) {
        let data = err.response.data;
        if (data.message !== undefined) {
          this.errors.push(data.code);
        }
      } else if (err?.response?.data) {
        this.errors.push(err?.response?.data);
      } else if (err) {
        this.errors.push(err);
      }
    } finally {
      this.isSendProfile = false;
      this.$emit("close");
    }
  }
}
